import { Box, styled } from '@ltvco/refresh-lib/theme';

import { type ClassActionSearchCard } from '../../types';
import { type ViewType } from '../shared';

import {
  ClassActionLawsuitResultCard,
  resolveClassActionDocketIdForReport,
} from './ClassActionLawsuitResultCard';

export interface ClassActionLawsuitResultsProps {
  results: ClassActionSearchCard[];
  viewType?: ViewType;
}

const CardsGrid = styled(Box)(({ theme }) => ({
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fill, minmax(min(100%, 320px), 1fr))',
  // Two row tracks per card row so Cause panels share one track height (CSS subgrid on cards).
  gridAutoRows: 'auto auto',
  alignItems: 'stretch',
  columnGap: theme.spacing(2.5),
  rowGap: theme.spacing(2),
  width: '100%',
}));

export const ClassActionLawsuitResults = ({
  results,
}: ClassActionLawsuitResultsProps) => {
  if (!results?.length) {
    return <Box sx={{ width: '100%' }}></Box>;
  }

  return (
    <Box sx={{ width: '100%' }}>
      <CardsGrid>
        {results.map((card, index) => (
          <ClassActionLawsuitResultCard
            key={
              resolveClassActionDocketIdForReport(card) ??
              `${card.case_title}-${index}`
            }
            card={card}
          />
        ))}
      </CardsGrid>
    </Box>
  );
};
